/**
 * @file: Card.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * A borderless, elevated surface in the lead-detail voice — the container for
 * the outcome list and the reschedule picker.
 */

import {
  LD,
  cardShadowStyle,
} from '@euler/app/flows/leads/pages/detail/components/leadDetailKit';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { View } from 'react-native';

export const Card = ({ children }: { children: React.ReactNode }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      style={{
        backgroundColor: LD.surface,
        borderRadius: rpx(14),
        paddingHorizontal: rpx(16),
        ...cardShadowStyle(rpx),
      }}
    >
      {children}
    </View>
  );
};
